import {GetAdDetailsGenericError} from '../../ads/Errors/GetAdDetailsGenericError.js'
import {GetAdDetailsNotFoundError} from '../../ads/Errors/GetAdDetailsNotFoundError.js'
import {GetAdDetailsPartialContentError} from '../../ads/Errors/GetAdDetailsPartialContentError.js'
import GetSearchDataFromUrlError from '../../ads/Errors/GetSearchDataFromUrlError.js'
import {NotFoundAssistantError} from '../../assistant/Errors/NotFoundAssistantError.js'
import {ContactValidationSellerError} from '../../seller/Errors/ContactValidationSellerError.js'
import {EmptyEmailSellerError} from '../../seller/Errors/EmptyEmailSellerError.js'
import {EmptyNameSellerError} from '../../seller/Errors/EmptyNameSellerError.js'
import {GenericSellerError} from '../../seller/Errors/GenericSellerError.js'
import {GetInstantOfferNotFoundSellerError} from '../../seller/Errors/GetInstantOfferNotFoundSellerError.js'
import {InvalidEmailSellerError} from '../../seller/Errors/InvalidEmailSellerError.js'
import {InvalidPhoneSellerError} from '../../seller/Errors/InvalidPhoneSellerError.js'
import {SeoDataRequestError} from '../../seo/Errors/SeoDataRequestError.js'
import {SeoMakeModelFaqsError} from '../../seo/Errors/SeoMakeModelFaqsError.js'
import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {NotFoundSharedError} from '../../shared/Errors/NotFoundSharedError.js'
import {AlreadyCancelledTradeTransactionsError} from '../../transactions/Errors/AlreadyCancelledTradeTransactionsError.js'
import {CreateTradeTransactionsError} from '../../transactions/Errors/CreateTradeTransactionsError.js'
import {TransactionError} from '../../transactions/Errors/TransactionError.js'
import {TransactionNoContentError} from '../../transactions/Errors/TransactionNoContentError.js'
import {UpdateReservationPhoneNumberBadRequestTransactionsError} from '../../transactions/Errors/UpdateReservationPhoneNumberBadRequestTransactionsError.js'
import {UpdateReservationPhoneNumberNotRequiredTransactionsError} from '../../transactions/Errors/UpdateReservationPhoneNumberNotRequiredTransactionsError.js'
import {UpdateReservationPhoneNumberReservationNotFoundTransactionsError} from '../../transactions/Errors/UpdateReservationPhoneNumberReservationNotFoundTransactionsError.js'
import {UpdateReservationPhoneNumberUnexpectedTransactionsError} from '../../transactions/Errors/UpdateReservationPhoneNumberUnexpectedTransactionsError.js'
import {UpdatePhoneUserError} from '../../user/Errors/UpdatePhoneUserError.js'
import UserNotLoggedInUserError from '../../user/Errors/UserNotLoggedInUserError.js'
import {SearchHasNoFiltersUserAlertError} from '../../userAlerts/Errors/SearchHasNoFiltersUserAlertError.js'
import {GenericVehiclesError} from '../../vehicles/Errors/GenericVehiclesError.js'
import GetBodyTypeInfoVehiclesError from '../../vehicles/Errors/GetBodyTypeInfoVehiclesError.js'
import GetMarketedMakesVehiclesError from '../../vehicles/Errors/GetMarketedMakesVehiclesError.js'
import GetModelInfoVehiclesError from '../../vehicles/Errors/GetModelInfoVehiclesError.js'
import GetModelsGroupedByBodyTypeDoorsVehiclesError from '../../vehicles/Errors/GetModelsGroupedByBodyTypeDoorsVehiclesError.js'
import {GetPaginationSearchUrlVehiclesError} from '../../vehicles/Errors/GetPaginationSearchUrlVehiclesError.js'
import GetVersionInfoVehiclesError from '../../vehicles/Errors/GetVersionInfoVehiclesError.js'
import {NotFoundVehiclesError} from '../../vehicles/Errors/NotFoundVehiclesError.js'

const ADS_ERRORS = {
  GetAdDetailsGenericError,
  GetAdDetailsNotFoundError,
  GetAdDetailsPartialContentError,
  GetSearchDataFromUrlError
}

const USER_ERRORS = {UpdatePhoneUserError, UserNotLoggedInUserError}

const VEHICLES_ERRORS = {
  GetMarketedMakesVehiclesError,
  GetModelsGroupedByBodyTypeDoorsVehiclesError,
  GetModelInfoVehiclesError,
  GetBodyTypeInfoVehiclesError,
  GetVersionInfoVehiclesError,
  GenericVehiclesError,
  NotFoundVehiclesError,
  GetPaginationSearchUrlVehiclesError
}

const SELLER_ERRORS = {
  ContactValidationSellerError,
  EmptyEmailSellerError,
  EmptyNameSellerError,
  GenericSellerError,
  GetInstantOfferNotFoundSellerError,
  InvalidEmailSellerError,
  InvalidPhoneSellerError
}

const SEO_ERRORS = {
  SeoDataRequestError,
  SeoMakeModelFaqsError
}

const TRANSACTION_ERRORS = {
  AlreadyCancelledTradeTransactionsError,
  CreateTradeTransactionsError,
  TransactionError,
  TransactionNoContentError,
  UpdateReservationPhoneNumberBadRequestTransactionsError,
  UpdateReservationPhoneNumberNotRequiredTransactionsError,
  UpdateReservationPhoneNumberReservationNotFoundTransactionsError,
  UpdateReservationPhoneNumberUnexpectedTransactionsError
}

const USER_ALERT_ERRORS = {
  SearchHasNoFiltersUserAlertError
}

const ASSISTANT_ERRORS = {
  NotFoundAssistantError
}

const COMMON = {
  InvalidParamsSharedError,
  NotFoundSharedError
}

export default {
  GENERIC: 'GENERIC_ERROR',
  ...COMMON,
  ...ADS_ERRORS,
  ...USER_ERRORS,
  ...VEHICLES_ERRORS,
  ...SELLER_ERRORS,
  ...SEO_ERRORS,
  ...TRANSACTION_ERRORS,
  ...USER_ALERT_ERRORS,
  ...ASSISTANT_ERRORS
}
